export function generateAccessCode() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let code = "";
  for (let i = 0; i < 6; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(dateString) {
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTime(time) {
  if (!time) return null;
  return new Date(`2000-01-01T${time}`).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function formatLocalDate(dateString) {
  if (!dateString) return "";
  // Parse the date as local time to avoid timezone shifts
  const [year, month, day] = dateString.split("-");
  const localDate = new Date(
    parseInt(year),
    parseInt(month) - 1,
    parseInt(day)
  );
  return localDate.toLocaleDateString();
}

export function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

export function validatePlayerNumber(
  number,
  existingPlayers = [],
  excludePlayerId = null
) {
  const num = parseInt(number);
  if (isNaN(num) || num < 1 || num > 99) {
    return "Jersey number must be between 1 and 99";
  }

  const duplicate = existingPlayers.find(
    (p) => p.number === num && p.id !== excludePlayerId
  );

  if (duplicate) {
    return `Jersey number ${num} is already taken by ${duplicate.name}`;
  }

  return null;
}
